import React, {useCallback, useEffect, useState} from "react";
import {useMediaQuery} from "@mui/material";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import LinearProgress from "@mui/material/LinearProgress";
import {ContractHistoryTable} from "../components/tables/ContractHistoryTable";
import {PaymentHistoryTable} from "../components/tables/PaymentHistoryTable";
import {apiGet, formatDate} from "../utils";

export const fetchPlayerHistory = (selectedPlayer, setLoading, setPlayerHistory, setPaymentHistory) => {
    if (selectedPlayer && selectedPlayer.yahoo_id) {
        setLoading(true);
        console.log(`player: ${JSON.stringify(selectedPlayer, null, 2)}`);
        apiGet(`contract/history/${selectedPlayer.yahoo_id}`, (data) => {
            const contractHistory = {};
            if (data.data) {
                for (const c of data.data) {
                    if (!contractHistory[c.key]) contractHistory[c.key] = [];
                    const pickupType = c.previous_contract_key ? 'RFA kept' : 'Signed';
                    const salary = c.signing_salary > 0 ? c.signing_salary : '?'
                    contractHistory[c.key].push(`${formatDate(c.signed_date)} - ${pickupType} by ${c.signing_manager} for ${salary}|${c.signed_year}|${c.signed_week}`);
                    if (c.trade_key) {
                        contractHistory[c.key].push(`${formatDate(c.traded_date)} - Traded from ${c.from_manager} to ${c.to_manager}|${c.traded_year}|${c.traded_week}`);
                    }
                    if (c.dropped_year) {
                        const dropType = c.dropped_year - c.signed_year === 3 ? 'Expired' : 'Dropped';
                        contractHistory[c.key].push(`${formatDate(c.dropped_date)} - ${dropType}|${c.dropped_year}|${c.dropped_week}`);
                    }
                }
                for (const [key, eventStrings] of Object.entries(contractHistory)) {
                    contractHistory[key] = [...new Set(eventStrings)];
                    contractHistory[key].sort();
                }
                Object.entries(contractHistory).forEach(([k, v], idx) => {
                    console.log(`${idx + 1}: ${k}`);
                })
            }
            setPlayerHistory(contractHistory);
            if (data.data) {
                apiGet(`payment/history/player/${selectedPlayer.yahoo_id}`, (data) => {
                    setPaymentHistory(data.data);
                    setLoading(false);
                });
            } else {
                setPaymentHistory(null);
                setLoading(false);
            }
        });
    }
};

export const HistoryContainer = () => {
    const [allPlayers, setAllPlayers] = useState([]);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [playerHistory, setPlayerHistory] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState(null);
    const [loading, setLoading] = useState(false);

    const isMobile = useMediaQuery('(max-width: 680px)');

    const fetchAllPlayers = () => {
        apiGet(`player/all`, (data) => {
            setAllPlayers(data.data);
        });
    };

    const fetchPlayerContractHistory = useCallback(() => {
        fetchPlayerHistory(selectedPlayer, setLoading, setPlayerHistory, setPaymentHistory);
    }, [selectedPlayer]);

    useEffect(() => {
        fetchAllPlayers();
    }, []);

    useEffect(() => {
        fetchPlayerContractHistory();
    }, [selectedPlayer, fetchPlayerContractHistory]);

    const onPlayerChange = (event, value) => {
        setSelectedPlayer(value);
    };

    const justify = isMobile ? 'flex-start' : 'center';
    return (
        <Grid container justifyContent={justify}>
            <div style={{marginTop: 50, marginBottom: 50, marginLeft: 10, marginRight: 10}}>
                <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 10}}>
                    Player:
                </Typography>
                <Autocomplete id="playerSelectionField" freeSolo style={{width: 670}} options={allPlayers}
                              getOptionLabel={(p) => `${p.first_name} ${p.last_name} (${p.pos} - ${p.team})`}
                              getOptionKey={(p) => p.yahoo_id}
                              onChange={onPlayerChange}
                              renderInput={(params) => (
                                  <TextField {...params} label="Search" margin="normal" variant="outlined"/>
                              )}/>
                {loading && <LinearProgress color="secondary"/>}
                {playerHistory &&
                    <div style={{marginTop: 30}}>
                        <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 10}}>
                            Contract History:
                        </Typography>
                        <ContractHistoryTable playerHistory={playerHistory}/>
                    </div>}
                {paymentHistory &&
                    <div style={{marginTop: 40}}>
                        <Typography variant="h6" color="inherit" display="inline" style={{marginLeft: 10}}>
                            Payment History:
                        </Typography>
                        <PaymentHistoryTable paymentHistory={paymentHistory}/>
                    </div>}
                <br/>
                <br/>
            </div>
        </Grid>
    );
}